var ua = navigator.userAgent;
/** 浏览器环境信息集合 */

export var Browser = function Browser() {};
/** 浏览器环境信息对象 */

export var BrowserInof = function BrowserInof() {};
var uaKey;

(function (uaKey) {
  uaKey["wx"] = "MicroMessenger";
  uaKey["qywx"] = "wxwork";
  uaKey["dingTalk"] = "dingtalk";
})(uaKey || (uaKey = {}));

;
/* 微信和企业微信的Ua可能性
  Mac: ... wxwork/2.2.0 (MicroMessenger/6.2) WeChat/2.0.4
  iPhone: ... wxwork/2.2.0 MicroMessenger/6.3.2
  Windows: ... wxwork/2.1.3 (MicroMessenger/6.2) WindowsWechat QBCore/3.43.644.400 QQBrowser/9.0.2524.400
  Android: ... wxwork/2.2.0 MicroMessenger/6.3.22 NetType/WIFI Language/zh
*/

var getUa = function getUa(key) {
  return ua.match(new RegExp(key + "/?([^\\s\\)]*)", 'i'));
}; // 获得微信客户端相关信息


var getWxBorwser = function getWxBorwser() {
  //   const wx = ua.match(new RegExp(`${wxKey}`, 'i'));
  // 匹配关键字并获得版本号，如果不安全，就用上面这个
  var uaMap = getUa(uaKey.wx);
  if (!uaMap) return null;
  var browser = {
    // 获取版本号
    version: uaMap[1] || ''
  };
  return browser;
}; // 获得企业微信客户端相关信息


var getQywxBorwser = function getQywxBorwser() {
  var uaMap = getUa(uaKey.qywx);
  if (!uaMap) return null;
  var browser = {
    // 获取版本号
    version: uaMap[1] || ''
  };
  return browser;
}; // 获得钉钉客户端相关信息


var getDingTalkBorwser = function getDingTalkBorwser() {
  var uaMap = getUa(uaKey.dingTalk);
  if (!uaMap) return null;
  var browser = {
    // 获取版本号
    version: uaMap[1] || ''
  };
  return browser;
};

export var browser = {
  wx: getWxBorwser(),
  qywx: getQywxBorwser(),
  dingTalk: getDingTalkBorwser()
};
export default browser;